module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button-primary', {
    staticClass: "search-button pull-right",
    attrs: {
      "id": "search-button",
      "label": _vm.$t("logDeAuditoria.labels.buscar"),
      "disabled": _vm.isDisabled,
      "type": "submit"
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e8324c6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e8324c6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/buttons/buttonSearch/buttonSearch.pug
// module id = 1392
// module chunks = 0